import { useHistory } from 'react-router'
import React from 'react'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import TitleDescriptionPage from 'components/EditPost/TitleDescriptionPage'
import { EditedJob } from 'components/EditJob'

export default function EditJobPostTitleDescriptionPage() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJob,
	})

	return (
		<TitleDescriptionPage
			mode={mode}
			initTitle={persistedJob.title}
			initDescription={persistedJob.description}
			isNextAvailable={true}

			onNext={(
				{
					title,
					description,
					changed
				},
			) => {
				saveJob({
					...persistedJob,
					title,
					description,
					changed
				})

				return 'postConfirmation'
			}}
		/>
	)
}
